<table *ngIf="carDetails" class="table table-hover">
  <tbody>
    <tr *ngFor="let feature of carDetails?.variant?.features">
      <td>{{feature.name | prettyText | titlecase}}</td>
      <td><b>{{feature.value}}</b></td>
    </tr>
  </tbody>
</table>